
















import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import WalletDetails from '@/components/wallet/shared/WalletDetails.vue';
import TransactionsList from '@/components/wallet/TransactionsList.vue';
import { Transactions, Wallet } from '@/store/wallet/types';
import { User } from '@/store/profile/types';

@Component({
  name: 'transactions-view',
  components: {
    TransactionsList,
    WalletDetails,
  },
})
export default class TransactionsView extends Vue {

  @Getter('wallet/transactions') transactions?: Transactions;
  @Getter('wallet/loadingTransactions') loadingTransactions?: Boolean;
  @Getter('wallet/wallet') wallet?: Wallet;
  @Getter('profile/user') user?: User;

  @Action('wallet/fetchTransactions') fetchTransactions: Function;

  onUpdate(val) {
    this.fetchTransactions(val);
  }
}
